export enum AdvertisingStatus {
    ALL = 'All',
    UNPOSTED = 'Unposted',
    ACTIVE = 'Active',
    EXPIRED = 'Expired',
}

export enum JobStatus {
    ALL = 'All',
    OPEN = 'Open',
    CLOSED = 'Closed'
}

// VI-375: field the Jobs-tab search bar searches by. Values match the `searchBy`
// query param the BFF /api/v1/job/search endpoint expects.
export enum JobSearchBy {
    JOB_TITLE = 'jobTitle',
    JOB_ID = 'jobId',
    REQ_ID = 'reqId',
}

// Display label shown in the "Search by" dropdown for each option.
export const JOB_SEARCH_BY_LABELS: Record<JobSearchBy, string> = {
    [JobSearchBy.JOB_TITLE]: 'Job Title',
    [JobSearchBy.JOB_ID]: 'Job ID',
    [JobSearchBy.REQ_ID]: 'Req ID',
};

// Placeholder shown in the search input for each option (VI-375 AC #2-4).
export const JOB_SEARCH_BY_PLACEHOLDERS: Record<JobSearchBy, string> = {
    [JobSearchBy.JOB_TITLE]: 'Enter Job Title',
    [JobSearchBy.JOB_ID]: 'Enter Job ID',
    [JobSearchBy.REQ_ID]: 'Enter Req ID',
};